import { render, staticRenderFns } from "./LinkEntityRolesList.vue?vue&type=template&id=1ab69367&scoped=true"
import script from "./LinkEntityRolesList.vue?vue&type=script&lang=js"
export * from "./LinkEntityRolesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab69367",
  null
  
)

export default component.exports